import { AxiosResponse } from "axios";
import ApiResponse from "../models/ApiResponse";
import { InputMatrixRepetitionRequest, InputMatrixUpdate } from "../models/test-request/TestRequestInputMatrix";
import {
  InputMatrix,
  MatrixConfigurationRequest,
  MatrixConfigurationResponse,
} from "../models/test-series/TestSeriesMatrixConfiguration";
import Api from "./Api";

class MatrixConfigurationApi {
  constructor(private api: Api) {}

  public getMatrixConfiguration(testSeriesId: number, version: number): ApiResponse<MatrixConfigurationResponse> {
    return this.api.get(`/test-request/v2/test-series/${testSeriesId}/version/${version}/matrixconfiguration`);
  }

  public getDefaultMatrixConfiguration(
    testSeriesId: number,
    version: number,
  ): ApiResponse<MatrixConfigurationResponse> {
    return this.api.get(`/test-request/v2/test-series/${testSeriesId}/version/${version}/matrixconfiguration/default`);
  }

  public updateMatrixConfiguration(
    testSeriesId: number,
    version: number,
    data: MatrixConfigurationRequest,
  ): ApiResponse<MatrixConfigurationResponse> {
    return this.api.put(`/test-request/v2/test-series/${testSeriesId}/version/${version}/matrixconfiguration`, data);
  }

  public deleteMatrixConfiguration(testSeriesId: number, version: number): ApiResponse<AxiosResponse> {
    return this.api.delete(`/test-request/v2/test-series/${testSeriesId}/version/${version}/matrixconfiguration`);
  }

  public getInputMatrix(testSeriesId: number, version: number, testCaseIds: number[]): ApiResponse<InputMatrix> {
    const params = new URLSearchParams();
    testCaseIds.forEach((id) => params.append("testCaseIds", String(id)));
    return this.api.get(`/test-request/v2/test-series/${testSeriesId}/version/${version}/inputmatrix`, { params });
  }

  public updateInputMatrix(
    testSeriesId: number,
    version: number,
    data: InputMatrixRepetitionRequest[],
    testCaseIds: number[],
  ): ApiResponse<InputMatrixUpdate> {
    const params = new URLSearchParams();
    testCaseIds.forEach((id) => params.append("testCaseIds", String(id)));
    return this.api.put(`/test-request/v2/test-series/${testSeriesId}/version/${version}/inputmatrix`, data, {
      params,
    });
  }
}

export default MatrixConfigurationApi;
